import { createSelector } from "reselect";
import { getPrescriptionGlasses } from "../../../state/selectors.internal.js";
const getConfigurator = createSelector(
  getPrescriptionGlasses,
  (pg) => pg.configurator
);
export {
  getConfigurator
};
//# sourceMappingURL=selectors.internal.js.map
